import React, {Component} from "react";
// import history from 'services/History'
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Tos from './components/tos';
import Privacy from './components/privacy';
import MainPage from './MainPage';

class App extends Component {
	render() {
		return (
			<Router>
				<div className="">
					<Switch>
						<Route path="/" component={MainPage} exact/>
						<Route path="/tos" component={Tos} exact/>
						<Route path="/privacy" component={Privacy} exact/>
					</Switch>
				</div>
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx